<mat-drawer-container autosize style="background: white">
    <mat-drawer #drawer [mode]="'side'" position="end">
        <div class="container">
            <h3 class="padding-top-15">Filters</h3>
            <mat-divider></mat-divider>
            <mat-form-field class="padding-top-15">
                <mat-label>Location</mat-label>
                <mat-select [(ngModel)]="filters.location.value" (selectionChange)="updateFilter()">
                    <mat-option value="">All locations</mat-option>
                    <mat-option *ngFor="let location of locations"
                                [value]="location.vetSourceId">{{location.name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-divider></mat-divider>
            <mat-form-field class="padding-top-15">
                <mat-label>Type</mat-label>
                <mat-select [(ngModel)]="filters.jobType.value" (selectionChange)="updateFilter()">
                    <mat-option value="">All types</mat-option>
                    <mat-option value="MAIN">MAIN</mat-option>
                    <mat-option value="RECON">RECON</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-divider></mat-divider>
            <mat-form-field class="padding-top-15">
                <mat-label>Status</mat-label>
                <mat-select [(ngModel)]="filters.jobStatus.value" (selectionChange)="updateFilter()">
                    <mat-option value="">All statuses</mat-option>
                    <mat-option value="PENDING">PENDING</mat-option>
                    <mat-option value="IN_PROGRESS">IN_PROGRESS</mat-option>
                    <mat-option value="SUCCESS">SUCCESS</mat-option>
                    <mat-option value="ERROR">ERROR</mat-option>
                    <mat-option value="INTERRUPTED">INTERRUPTED</mat-option>
                </mat-select>
            </mat-form-field>
            <br/>
            <button (click)="drawer.toggle()" mat-stroked-button>
                <mat-icon aria-hidden="false">close</mat-icon>
                Close
            </button>&nbsp;
            <button (click)="resetGrid()" mat-stroked-button color="accent">
                <mat-icon aria-hidden="false">refresh</mat-icon>
                Reset
            </button>
        </div>
    </mat-drawer>

    <mat-drawer-content style="padding-top: 15px">
        <h5 class="card-title text-muted">Monitoring:
            <span class="col col-sm-2">
                Job Status: <b>{{status}}</b>
            </span>
            <span class="col col-sm-2">
                Last check: <small>{{lastCheck | date: 'hh:mm:ss'}}</small>
            </span>
        </h5>

        <mat-tab-group mat-stretch-tabs>
            <mat-tab label="Job Run">
                <div class="margin-top-15 padding-bottom-15">
                    <div class="container">
                        <div class="row fieldset padding-top-10">
                            <div><span><b>Logs</b></span></div>
                            <div class="col col-sm-10 col-xs-12 text-center padding-bottom-15">
                                <a href="{{logsUrl}}" mat-icon-button
                                   color="primary" target="_blank"
                                   class="padding-top-15; top: -1em; position: relative;">
                                    View logs in GCP Logs Explorer
                                    <i class="bi bi-box-arrow-up-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="row fieldset padding-top-10">
                            <div><span><b>Main Job</b></span></div>
                            <div class="col col-sm-10 col-xs-12 padding-bottom-15 margin-bottom-15">
                                Runs daily but can be forced here. Extracts new data from Vetsource for all locations,
                                builds journals and pushes to Netsuite.
                            </div>
                            <div class="col-sm-2 col-xs-12">
                                <button (click)="runEtlJob()"
                                        class="btn btn-primary btn-spinner" [class.transparent-button]="progress"
                                        [disabled]="progress || status == runningJobStatus">
                                    Force a job run
                                </button>
                            </div>
                        </div>
                        <div class="row fieldset padding-top-10">
                            <div><span><b>Reconciliation job</b></span></div>
                            <div class="col-sm-3 col-xs-12">
                                <mat-form-field style="width: 100%">
                                    <mat-label>Location</mat-label>
                                    <mat-select [(ngModel)]="selectedLocation" [disabled]="progress" required>
                                        <mat-option *ngFor="let location of locations"
                                                    [value]="location">{{location.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-2 col-xs-12">
                                <mat-form-field style="width: 100%">
                                    <mat-label>From</mat-label>
                                    <input matInput [disabled]="progress" [formControl]="fromDate"
                                           [matDatepicker]="fromDateId"
                                           required>
                                    <mat-datepicker-toggle matSuffix [for]="fromDateId"></mat-datepicker-toggle>
                                    <mat-datepicker #fromDateId></mat-datepicker>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-2 col-xs-12">
                                <mat-form-field style="width: 100%">
                                    <mat-label>To</mat-label>
                                    <input matInput [disabled]="progress" [formControl]="toDate"
                                           [matDatepicker]="toDateId"
                                           required>
                                    <mat-datepicker-toggle matSuffix [for]="toDateId"></mat-datepicker-toggle>
                                    <mat-datepicker #toDateId></mat-datepicker>
                                </mat-form-field>
                            </div>

                            <div class="col-sm-3 col-xs-12">
                                <mat-checkbox [disabled]="progress" [(ngModel)]="synchronizeMappings">
                                    Synchronize mappings
                                </mat-checkbox><br/>
                                <mat-checkbox [disabled]="progress" [(ngModel)]="forceExtract">
                                    Vetsource extract
                                </mat-checkbox>
                            </div>

                            <div class="col-sm-2 col-xs-12">
                                <button (click)="reconcileJournals()"
                                        class="btn btn-primary btn-spinner" [class.transparent-button]="progress"
                                        [disabled]="!selectedLocation || !fromDate.value || !toDate.value || fromDate.value > toDate.value || progress">
                                    Reconcile Journals
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Job History">
                <div class="row padding-top-10">
                    <div class="col col-lg-2">
                        <button mat-icon-button color="primary" (click)="drawer.toggle()" class="margin-top-10">
                            <mat-icon aria-hidden="false">tune</mat-icon>
                            <span *ngIf="calculateActiveFiltersCount() > 0"
                                  class="badge badge-small">{{calculateActiveFiltersCount()}}</span>
                        </button>
                        <button mat-icon-button color="primary" (click)="resetGrid()">
                            <mat-icon aria-hidden="false">refresh</mat-icon>
                        </button>
                    </div>
                </div>
                <mat-divider></mat-divider>
                <div class="table-container">
                    <div class="table-loading-shade"
                         *ngIf="isLoadingResults">
                        <mat-spinner [diameter]="50" *ngIf="isLoadingResults"></mat-spinner>
                    </div>

                    <div class="table-box">
                        <table mat-table [dataSource]="data"
                               matSort matSortActive="createdAt" matSortDisableClear matSortDirection="desc">

                            <ng-container matColumnDef="createdAt" sticky>
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
                                <td mat-cell *matCellDef="let row">{{row.createdAt | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                            </ng-container>

                            <ng-container matColumnDef="locationName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
                                <td mat-cell *matCellDef="let row">{{row.locationName}}</td>
                            </ng-container>


                            <ng-container matColumnDef="type">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                                <td mat-cell *matCellDef="let row">{{row.type}}</td>
                            </ng-container>

                            <ng-container matColumnDef="totalAmt">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Jobs</th>
                                <td mat-cell *matCellDef="let row">{{row.totalAmt}}</td>
                            </ng-container>

                            <ng-container matColumnDef="successAmt">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Successful Jobs</th>
                                <td mat-cell *matCellDef="let row">{{row.successAmt}}</td>
                            </ng-container>

                            <ng-container matColumnDef="failedAmt">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Failed Jobs</th>
                                <td mat-cell *matCellDef="let row">{{row.failedAmt}}</td>
                            </ng-container>

                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                                <td mat-cell *matCellDef="let row" [matTooltip]="row.error">
                                    <span [ngClass]="row.status == 'ERROR' ? 'red-notice cursor-default' : (row.status == 'SUCCESS' ? 'green-notice' : '')">{{row.status}}</span>
                                    <mat-icon *ngIf="row.status == 'ERROR'" class="font-18">help_outline</mat-icon>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="star" stickyEnd>
                                <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-icon-button [matMenuTriggerFor]="menu" class="example-icon">
                                        <mat-icon *ngIf="!element.loading">more_vert</mat-icon>
                                        <mat-spinner *ngIf="element.loading" diameter="20"></mat-spinner>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item (click)="openViewDialog(element)">
                                            <mat-icon>remove_red_eye</mat-icon>
                                            <span>View</span>
                                        </button>
                                        <button [disabled]="element.status == 'IN_PROGRESS' || element.status == 'PENDING'"
                                                mat-menu-item (click)="openDeleteDialog(element)">
                                            <mat-icon>delete</mat-icon>
                                            <span>Delete</span>&nbsp;
                                        </button>
                                    </mat-menu>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>

                    <mat-paginator [length]="resultsLength" [pageSize]="pageSize"
                                   [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                </div>
            </mat-tab>
        </mat-tab-group>
    </mat-drawer-content>
</mat-drawer-container>
